<template>
	<div>
		<div id="geoAssistance" style="height: 350px;" />
	</div>
</template>

<script>
export default {
	props: {
		position: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			marker: null,
			map: null,
		};
	},
	mounted() {
		this.setMap();
	},
	methods: {
		setMap() {
			// eslint-disable-next-line no-undef
			this.map = new google.maps.Map(document.getElementById('geoAssistance'), {
				zoom: 17,
				streetViewControl: false,
				scaleControl: true,
				fullscreenControl: false,
				scrollwheel: true,
			});
			// eslint-disable-next-line no-undef
			this.marker = new google.maps.Marker({
				position: this.position,
				map: this.map,
			});
			this.map.setCenter(this.position);
			this.marker.setMap(this.map);
		},
	},
	watch: {
		position: {
			deep: true,
			handler(newValue) {
				this.marker.setMap(null);
				// eslint-disable-next-line no-undef
				this.marker = new google.maps.Marker({
					position: newValue,
					map: this.map,
				});
				this.map.setCenter(this.position);
				this.marker.setMap(this.map);
			},
		},
	},
};
</script>
